import { delay } from 'redux-saga';
import { put, takeLatest } from 'redux-saga/effects';

import { Types } from 'services/genericAPIGatewayService';
import { Actions } from './actions';

const triggers = [
  Types.CREATE_COMPLETED,
  Types.CREATE_FAILED,
  Types.UPDATE_COMPLETED,
  Types.UPDATE_FAILED,
  Types.DELETE_COMPLETED,
  Types.DELETE_FAILED,
  Types.PATCH_COMPLETED,
  Types.PATCH_FAILED,
];

export function* notificationBarSaga() {
  yield takeLatest(triggers, hideAfterDelay);
}

function* hideAfterDelay() {
  yield delay(5000);
  yield put(Actions.closeNotification());
}
